<!-- 邀请链接组件 -->
<template>
  <div>
    <!-- 复制功能包装器 -->
    <div v-clipboard:copy="invitePrefix + inviteLink" v-clipboard:success="handleTriggerCopy">
      <!-- 自定义触发器 -->
      <slot name="trigger" />
    </div>

    <!-- 邀请链接弹窗 -->
    <popup-frame ref="invite-link" size="mini" @opened="showCopySuccess">
      <h2 style="font-size: 0.5rem; font-family: 'Source Han Serif SC Bold'">你的专属链接已生成</h2>
      <div :class="$style['invite-link']">
        <div :class="$style['invite-link-text']">{{ inviteLink }}</div>
        <!-- 复制链接 -->
        <button
          v-clipboard:copy="invitePrefix + inviteLink"
          v-clipboard:success="showCopySuccess"
          v-clipboard:error="onError"
          :class="$style['invite-link-copy']"
        />
      </div>
      <p style="font-size: 0.2rem">
        <em>点击复制链接即可复制您的专属链接分享给您的好友一起领福利！</em>
      </p>
    </popup-frame>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PopupFrame } from '@/components/widgets'

export default {
  name: 'InviteLink',
  components: {
    PopupFrame
  },
  computed: {
    ...mapGetters(['teamInviteCode', 'inviteShareText', 'teamName']),
    invitePrefix() {
      return this.inviteShareText
        ? this.inviteShareText
            .replaceAll('%code%', this.teamInviteCode)
            .replaceAll('%name%', this.teamName)
        : ''
    },
    inviteLink() {
      const url = new URL(location.href)
      url.searchParams.set('code', this.teamInviteCode)
      return url.toString()
    }
  },
  methods: {
    handleTriggerCopy() {
      // 复制成功后自动打开弹窗
      this.$refs['invite-link'].show()
      // 触发自定义事件，通知外层组件复制成功
      this.$emit('copy-success')
    },
    onError() {
      this.$toast('复制失败，请换个浏览器试试！')
    },
    showCopySuccess() {
      this.$toast('您已复制加队链接')
    }
  }
}
</script>

<style lang="less" module>
.invite-link {
  .size(6.12rem, 0.95rem);
  .background-fill('./images/invite-link-bg.png');

  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.4rem 0;
  padding: 0 0.2rem 0 0.6rem;

  &-text {
    flex: 1;
    font-size: 0.26rem;
    color: fade(#c43137, 50%);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &-copy {
    .size(1.6rem, 0.54rem);
    .background-fill('./images/invite-link-copy.png');
  }
}
</style>
